import { css } from '@emotion/react'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageLoading } from 'components/loading'
import { TitleGroup } from 'components/TitleGroup'
import { useAtividadeColetivaEditarSaudeQuery } from 'graphql/hooks.generated'
import { Fragment } from 'react'
import { Redirect, useParams } from 'react-router'

import { useAtividadeColetivaCache } from '../hooks/useAtividadeColetivaCache'
import AtividadeColetivaSaudeForm from './AtividadeColetivaSaudeForm'
import { convertAtividadeColetivaSaudeToFormModel } from './converter-atividadeColetivaSaude'

interface AtividadeColetivaEditarSaudeViewProps {
  atividadeColetivaId: ID
}

export const AtividadeColetivaEditarSaudeView = () => {
  const { atividadeColetivaId } = useParams<AtividadeColetivaEditarSaudeViewProps>()
  const { cachedValue, setCachedValue, clearCachedValue } = useAtividadeColetivaCache()

  const {
    data: { atividadeColetiva },
    loading,
  } = useAtividadeColetivaEditarSaudeQuery({
    variables: { atividadeColetivaId },
  })

  if (loading) {
    return <PageLoading message='Carregando' />
  } else if (!atividadeColetiva) {
    return <Redirect to='/404' />
  }

  return (
    <Fragment>
      <Breadcrumb title='Edição de registro de atividade coletiva em saúde' />
      <PageContent type='filled' style={styles.pageContent}>
        <TitleGroup title='Registro de atividade coletiva em saúde' style={styles.header} />
        <AtividadeColetivaSaudeForm
          initialValues={convertAtividadeColetivaSaudeToFormModel(atividadeColetiva)}
          initialDirtyFields={cachedValue}
          setCachedValue={setCachedValue}
          clearCachedValue={clearCachedValue}
        />
      </PageContent>
    </Fragment>
  )
}

const styles = {
  header: css`
    margin-top: 1rem;
    margin-bottom: 2rem;
  `,
  pageContent: css`
    padding-bottom: 3.5rem;
  `,
}
